import apiClient from '~/config/apiClient';
import { WriterModel } from '~/libs/types/writer.types';

import {
  FindAllProjectsParams,
  FindAllProjectsResult,
  ProjectClientSettingsDto,
  ProjectModel,
} from './types';

export const findAllProjects = (userId: string, params: FindAllProjectsParams) =>
  apiClient.get<FindAllProjectsResult>(`/users/${userId}/projects/v2`, { params });

export const findOneProject = (projectId: string) => {
  return apiClient.get<ProjectModel>(`/projects/${projectId}`);
};

export const findAllProjectUsers = (projectId: string) =>
  apiClient.get<WriterModel[]>(`/projects/${projectId}/users`);

export const getProjectClientSettings = (projectId: string) =>
  apiClient.get<ProjectClientSettingsDto>(`/projects/${projectId}/client-setting`);
